import { gql } from 'apollo-boost';

export const PREPARE_CHAT_ACTION = gql`
    mutation PrepareChatAction($data: PrepareChatActionInput!) {
        prepareChatAction(data: $data) {
            actionId
            prompt
        }
    }
`;
